import { configureStore } from "@reduxjs/toolkit";
import teamMemberReducer from '../Redux/Feature/teamMemberSlice'

const store = configureStore({
    reducer: {
        teamMember: teamMemberReducer
    }
});

export default store;